"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("../../utils/styled"));
exports.Body = styled_1.default("div")(({ theme, color }) => ({
    fontSize: theme.font.size.body,
    fontFamily: theme.font.family.main,
    fontWeight: theme.font.weight.regular,
    lineHeight: theme.font.lineHeight,
    margin: `0 0 ${theme.space.element}px 0`,
    color: theme.color.text[color || "default"],
}));
exports.default = exports.Body;
//# sourceMappingURL=index.js.map